var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_2709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68706 15.1252C3.48631 15.1252 2.41831 14.3565 2.03056 13.212L2.00431 13.1257C1.91281 12.8227 1.87456 12.5677 1.87456 12.3127V7.19922L0.0550585 13.2727C-0.178942 14.166 0.354309 15.0922 1.24906 15.339L12.8463 18.4447C12.9911 18.4822 13.1358 18.5002 13.2783 18.5002C14.0253 18.5002 14.7078 18.0045 14.8991 17.274L15.5748 15.1252H4.68706Z",
    fill: "#D31C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.25C7.57725 7.25 8.25 6.57725 8.25 5.75C8.25 4.92275 7.57725 4.25 6.75 4.25C5.92275 4.25 5.25 4.92275 5.25 5.75C5.25 6.57725 5.92275 7.25 6.75 7.25Z",
    fill: "#D31C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 2H4.875C3.8415 2 3 2.8415 3 3.875V12.125C3 13.1585 3.8415 14 4.875 14H16.125C17.1585 14 18 13.1585 18 12.125V3.875C18 2.8415 17.1585 2 16.125 2ZM4.875 3.5H16.125C16.332 3.5 16.5 3.668 16.5 3.875V9.19925L14.1308 6.43475C13.8795 6.14 13.5158 5.9825 13.125 5.9735C12.7365 5.97575 12.372 6.14825 12.123 6.44675L9.3375 9.79025L8.43 8.885C7.917 8.372 7.08225 8.372 6.57 8.885L4.5 10.9543V3.875C4.5 3.668 4.668 3.5 4.875 3.5Z",
    fill: "#D31C4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_2709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryImg);
export default __webpack_public_path__ + "static/media/GalleryImg.c47a0e1add420b4a3388358a1d8dadef.svg";
export { ForwardRef as ReactComponent };